export interface AccountNavItem {
  to: string
  label: string
  /** Match nested routes (e.g. /account/notifikationer/*). */
  end?: boolean
  adminOnly?: boolean
  /** Sidebar drills into a sub-menu — show → on hover. */
  drillDown?: boolean
}

export const ACCOUNT_NAV_ITEMS: AccountNavItem[] = [
  { to: '/account', label: 'Oversigt', end: true },
  { to: '/account/watchlist', label: 'Watchlist', drillDown: true },
  { to: '/account/notifikationer', label: 'Notifikationer' },
  { to: '/account/indstillinger', label: 'Kontoindstillinger' },
  { to: '/account/admin', label: 'Admin', adminOnly: true },
]
